import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CryptService } from '../services/crypt.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(private authService: CryptService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log(request);
    const auth = this.authService.encrypt();

    const Authorization = request.headers.get('byPass');
    if (Authorization !== 'true') {
      request = request.clone({
        setHeaders: {
          Authorization: auth
        }
      });
    } else {
      request.headers.delete('Authorization');
    }

    // this.authService.decrypt(auth);

    return next.handle(request);
  }
}
